export default function useColumns() {
  const exportColumns = [
    {
      title: '模块/数据项',
      slotName: 'moduleName',
      width: 200,
      fixed: 'left'
    },
    // {
    //   title: '数据项',
    //   dataIndex: 'dataItem',
    //   width: 180
    // },
    {
      title: '状态',
      slotName: 'status',
      width: 100
    },
    {
      title: '获取数据最新时间',
      dataIndex: 'lastCacheDataTime',
      width: 180
    },
    {
      title: '失败原因',
      slotName: 'failReason',
      width: 180
    },
    {
      title: '操作',
      slotName: 'operation',
      width: 100,
      fixed: 'right'
    }
  ];
  const importColumns = [
    {
      title: '模块/数据项',
      slotName: 'moduleName',
      width: 200,
      fixed: 'left'
    },
    // {
    //   title: '数据项',
    //   dataIndex: 'dataItem',
    //   width: 180
    // },
    {
      title: '状态',
      slotName: 'status',
      width: 100
    },
    {
      title: '进度',
      slotName: 'progress',
      width: 180
    },
    {
      title: '导入结果（飞书/智书）',
      slotName: 'importResult',
      width: 180
      // align: 'right'
    },
    {
      title: '导入时间',
      dataIndex: 'importStartTime',
      width: 180
    },
    {
      title: '导入实际完成时间',
      dataIndex: 'importEndTime',
      width: 180
    },
    {
      title: '导入已执行时间',
      dataIndex: 'importExecuteDuration',
      width: 120
    },
    {
      title: '失败原因',
      slotName: 'failReason',
      width: 180
    },
    {
      title: '操作',
      slotName: 'operation',
      width: 200,
      fixed: 'right'
    }
  ];
  return {
    importColumns,
    exportColumns
  };
}
